import { UserNameItem } from 'modules/user';
import { useSettings } from 'context/SettingsContext';
import type { TaskPayReportRowType } from '@econtractor/types';
import { formatIncomeLocal, formatIncomePrimary } from '../../ReportUsers/model';
import { sumTaskPay } from '../model';
import TaskPayRowsTable from './TaskPayRowsTable';

interface TaskPayBlockProps {
    user: TaskPayReportRowType;
}

const TaskPayBlock = ({ user }: TaskPayBlockProps) => {
    const { localSettings } = useSettings();
    const rate = Number(localSettings?.RATE?.current ?? 1) || 1;
    const isLocalMode = rate === 1;
    const totals = sumTaskPay(user.rows || [], rate);

    return (
        <div className="user-income-block mb-4">
            <div className="d-flex justify-content-between align-items-center gap-3 mb-2">
                <div className="min-w-0 flex-grow-1">
                    <UserNameItem
                        user={{
                            userName: user.userName,
                            userEmail: user.userEmail,
                            userPicture: user.userPicture || undefined,
                        }}
                    />
                </div>
                <div className="text-end flex-shrink-0">
                    <h6 className="mb-0">{formatIncomePrimary(totals.amount, rate)}</h6>
                    {!isLocalMode && (
                        <p className="text-muted f-12 mb-0">{formatIncomeLocal(totals.amountRate)}</p>
                    )}
                </div>
            </div>
            <TaskPayRowsTable rows={user.rows || []} />
        </div>
    );
};

export default TaskPayBlock;
